/*
 * Bootstrap file - Contains common initialization logic
 */

import * as Sentry from '@sentry/browser';
import 'alpinejs';
import FormLoader from 'vue-form-loader';

// Sentry setup
if (window.App.sentryDsn) {
    Sentry.init(
        {
            dsn: window.App.sentryDsn,
            release: window.App.sentryRelease,
            environment: window.App.environment,
        },
    );

    Sentry.configureScope(scope => {
        if (window.App.userId) {
            scope.setUser({ id: window.App.userId });
        }
    });
}

window.addEventListener('load', () => FormLoader.autoBindToForms());
